// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
// optional style for arrows & dots
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
import AMapLoader from '@amap/amap-jsapi-loader'
Vue.config.productionTip = false
export default {
  name: 'MyComponent',
  components: { VueSlickCarousel },
}
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})
AMapLoader.load({
  key: '970264a0bfc91832b5eecbf4be62c155', // 替换为你的API Key
  version: '2.0',
  plugins: ['AMap.DistrictSearch', 'AMap.Polygon'],
}).then((AMap) => {
  console.log('高德地图API加载完成');
  Vue.prototype.$AMap = AMap; // 将AMap挂载到Vue原型上


  new Vue({
    router,
    render: (h) => h(App)
  }).$mount('#app');
}).catch((e) => {
  console.error('地图加载失败', e);
});


// WEBPACK FOOTER //
// ./src/main.js